module.exports = __webpack_public_path__ + "media/images/metronic/social/googleplus-96020e30e8638f00089f22c7e675c1fe.png";